<template>
  <q-card inline class="cursor-pointer full-width" @click.native="showNews()">
        <q-card-media>
            <img :src="getImage">
        </q-card-media>

        <q-card-title>
            {{ news.title }}
        </q-card-title>

        <q-card-separator />

        <q-card-actions class="justify-center">
            <q-btn flat :label="fDate(news.created_date)" icon="fal fa-calendar" />
        </q-card-actions>
    </q-card>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { formatDate } = date

export default {
    name: 'NewsCard',

    props: ['news'],

    computed: {
        ...mapGetters({
            id_user_language_selected: 'common/id_user_language_selected'
        }),

        getImage() {
            let img = this.news.images_news.find((obj) => { return obj.name === '160x90' })
            if (img && img.image_url) return img.image_url
            else return 'placeholders/news.png'
        }
    },

    methods: {
        showNews() {
            this.$emit('showNews', this.news.id)
        },

        fDate(d) {
            if (d) {
                let format = ''

                switch(this.id_user_language_selected) {
                    case 1:
                    case 3: format = 'DD/MM/YYYY HH:mm:ss'
                    break
                    default: format = 'MM-DD-YYYY HH:mm:ss'
                    break
                }

                return date.formatDate(d, format)
            }
        }
    }
}
</script>

<style>

</style>